/*
Normally we use Turbo for forms, and Turbo automatically disables the submit button while waiting
for the server to respond, so as to avoid a double-click.

But there are a few forms where we disable turbo (with turbo: false).  In those cases, we use this
form to similarly disable the submit button.

Note that this controller does NOT include the logic to re-enable the button after we get a response
from the server.  This doesn't matter for our current use cases, but it might in the future.
*/

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("submit", this.disableSubmitButton.bind(this));
  }

  disableSubmitButton() {
    this.element.querySelectorAll("[type=submit]").forEach((button) => {
      button.disabled = true;
    });
  }
}
